/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
  TelegramTransactionsUserControllerGetTopUpVariants401,
} from '../../types/TelegramTransactionsUserControllerGetTopUpVariants.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramTransactionsUserGetTopUpVariants } from '../../methods/telegramTransactionsUserGetTopUpVariants.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramTransactionsUserGetTopUpVariantsQueryKey = () =>
  [{ url: '/api/user/telegram/transactions/top-up-variants' }] as const;

export type TelegramTransactionsUserGetTopUpVariantsQueryKey = ReturnType<
  typeof telegramTransactionsUserGetTopUpVariantsQueryKey
>;

export function telegramTransactionsUserGetTopUpVariantsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramTransactionsUserGetTopUpVariantsQueryKey();
  return queryOptions<
    TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerGetTopUpVariants401>,
    TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramTransactionsUserGetTopUpVariants(config);
    },
  });
}

/**
 * {@link /api/user/telegram/transactions/top-up-variants}
 */
export function useTelegramTransactionsUserGetTopUpVariants<
  TData = TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
  TQueryData = TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
  TQueryKey extends QueryKey = TelegramTransactionsUserGetTopUpVariantsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
        ResponseErrorConfig<TelegramTransactionsUserControllerGetTopUpVariants401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramTransactionsUserGetTopUpVariantsQueryKey();

  const query = useQuery(
    {
      ...telegramTransactionsUserGetTopUpVariantsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramTransactionsUserControllerGetTopUpVariants401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
